export const NUM_TOPICS = 12